import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * A route change starts at the top of the new page. Without this, a footer
 * link opened the privacy policy, the terms or the changelog at the scroll
 * position the previous page had - the bottom, since that is where the
 * footer is. In-page anchors (#features) keep their own scroll. The scroll
 * is instant on purpose: the document has scroll-behavior: smooth, and a
 * smooth scroll started while the old page is being torn down is dropped.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
